/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CountryResource } from '../models/CountryResource'

import type { CancelablePromise } from '../core/CancelablePromise'
import type { BaseHttpRequest } from '../core/BaseHttpRequest'

export class CountriesService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * List all countries.
     * @returns any OK
     * @throws ApiError
     */
    public getAllCountries(): CancelablePromise<{
        data: Array<CountryResource>
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/countries',
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }
}
